import * as IconSelector from '../icons';

// Constantes exportadas
export const RESULT_RESOLUTION_FAVORABLE = 'Favorable';
export const RESULT_RESOLUTION_NO_FAVORABLE = 'No favorable';
export const RESULT_RESOLUTION_PENDIENTE = 'Pendiente';

// Definición del enum
export const resultsResolution = [
    {
        value: null,
        label: 'Sin definir',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: RESULT_RESOLUTION_FAVORABLE,
        label: 'Favorable',
        description: 'Resultado favorable',
        icon: IconSelector.VerifiedIcon,
        color: 'Green'
    },
    {
        value: RESULT_RESOLUTION_NO_FAVORABLE,
        label: 'No Favorable',
        description: 'Resolución desfavorable',
        icon: IconSelector.RejectIcon,
        color: 'DarkRed'
    },
    {
        value: RESULT_RESOLUTION_PENDIENTE,
        label: 'Pendiente',
        description: 'Resultado pendiente',
        icon: IconSelector.PendingIcon,
        color: 'DarkOrange'
    }
];
